$(document).ready(function() {
    $("map#school-map").imageMapResize();
});